import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

const PARAM = 'panel'

/**
 * Drawer state lives in the URL as `?panel=<key>` so a drawer is linkable and
 * the back button closes it. Opening pushes a history entry; closing replaces
 * so back does not re-open it. Other query params are preserved.
 */
export function useDrawerParam(): {
  panel: string | null
  open: (key: string) => void
  close: () => void
} {
  const [params, setParams] = useSearchParams()

  const open = useCallback(
    (key: string) => {
      setParams(
        (prev) => {
          const next = new URLSearchParams(prev)
          next.set(PARAM, key)
          return next
        },
        { replace: false }
      )
    },
    [setParams]
  )

  const close = useCallback(() => {
    setParams(
      (prev) => {
        const next = new URLSearchParams(prev)
        next.delete(PARAM)
        return next
      },
      { replace: true }
    )
  }, [setParams])

  return { panel: params.get(PARAM), open, close }
}
